export enum ETouchType {
  Postcard = 'POSTCARD',
  Letter = 'LETTER',
  Email = 'EMAIL',
  Text = 'TEXT',
  Voicemail = 'VOICEMAIL',
}
